import config from './config';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import * as moment from 'moment';


class APIClient {
  constructor(overrides) {
    this.config = {
      ...config,
      ...overrides,
    };
    this.authToken = config.authToken;
    this.apiClient = this.getApiClient(this.config);
  }

  getApiClient(config) {
    const initialConfig = {
      baseURL: `${config.apiBasePath}/api`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const client = axios.create(initialConfig);
    // client.interceptors.request.use(localStorageTokenInterceptor);
    return client;
  }

  fetchUser(token) {
    return this.apiClient.get('/users/me/', {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(({data}) => {      
      localStorage.setItem('user', JSON.stringify(data));
      return data;
    });
  }

  // Admin Dashboard
  getIngestionLog() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_ingestion_log/`, {
      headers: send_headers['headers']
    });
  }

  getActivityLog() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_activity_log/`, {
      headers: send_headers['headers']
    });
  }

  getUserList() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_users/`, {
      headers: send_headers['headers']
    });
  }

  getFunderList() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/retrieve_funder_display/`, {
      headers: send_headers['headers']
    });
  }

  updateFunder(funder_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post('/v1/funder/update_funder_display/', funder_obj, {
      headers: send_headers['headers']
    }).then(
      (resp) => {
        return resp.data;
      });
  }

  // Admin User Permission
  getUser(email) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_user/` ,{
      params: {
        in_email: email
      },
      headers: send_headers['headers']
    });
  }

  getUserPermission(user_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_user_permissions/` ,{
      params: {
        user_id: user_id
      },
      headers: send_headers['headers']
    });
  }

  updateUser(user_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    const userRecord = {
      email: user_obj.email,
      is_active: user_obj.userIsActive,
      is_superuser: user_obj.userIsSuper,
      is_fund_viewer: user_obj.userIsFundViewer,
      is_opportunity_viewer: user_obj.userIsOpportunityViewer,
      first_name: user_obj.userFirstName,
      last_name: user_obj.userLastName,
      idp_id: null,
    }

    return this.apiClient.post('/users/update/', userRecord, {
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });

  };

  addUserPermission(permission_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    const data = {
      view_unmasked: permission_obj.view_unmasked,
      funder_view_id: permission_obj.portfolio,
      user_id: permission_obj.permissionUser
    };

    return this.apiClient.post('/v1/utils/add_user_permission/', data, {
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });

  };

  removeUserPermission(in_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post(`/v1/utils/remove_user_permission/`, {}, {
      params: { permission_id: in_id },
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });
  };

  syncUser(in_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post(`/users/sync/`, {}, {
      params: { user_id: in_id },
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });

  };

  //Admin Opportunity Map Management
  getAllMapDisplays() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/prediction/map/all/`, {
      headers: send_headers['headers']
    });
  }

  getAvailableMapDisplays() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/prediction/map/?is_available=true`, {
      headers: send_headers['headers']
    });
  }

  updateAvailableMapDisplays(map_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post('/v1/prediction/map/update/', map_obj, {
      headers: send_headers['headers']
    }).then(
      (resp) => {
        return resp.data;
      });
  }

  //Admin Funder Capital
  getFunderCapitalViews() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/return_funder_capital_views/`, {
      headers: send_headers['headers']
    });
  };

  getFunderCapital(funder_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/return_funder_capital/` ,{
      params: {
        funder_id: funder_id
      },
      headers: send_headers['headers']
    });
  };


  addFunderCapital(capital_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    const data = {
      funder_view_id: capital_obj.funder_view_id,
      avg_net_book: capital_obj.avg_net_book,
      total_fee: capital_obj.total_fee,
      start_date: capital_obj.start_date
    };

    return this.apiClient.post('/v1/funder/create_funder_capital/', data, {
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });
  };

  updateFunderCapital(capital_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    const data = {
      id: capital_obj.id,
      funder_view_id: capital_obj.funder_view_id,
      avg_net_book: capital_obj.avg_net_book,
      total_fee: capital_obj.total_fee,
      start_date: capital_obj.start_date
    };

    return this.apiClient.post('/v1/funder/update_funder_capital/', data, {
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });
  };

  //admin api keys
  getAllApiKeys() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/utils/retrieve_app_keys/`, {
      headers: send_headers['headers']
    });
  }

  addApiKey(key_obj) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post(`/v1/utils/add_app_key/`, {}, {
      params: { key_name: key_obj.key_name },
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });

  }

  removeApiKey(key_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.post(`/v1/utils/remove_app_key/`, {}, {
      params: { key_id: key_id },
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });

  }

  // Platform Dashboard
  getPlatformSummary(partner) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/platform/retrieve_summary/?partner=${partner}`, {
      headers: send_headers['headers']
    });
  }

  getPlatformOverview(partner) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/platform/retrieve_overview/?partner=${partner}`, {
      headers: send_headers['headers']
    });
  }

  // Investor Dashboard
  getFunderNames() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/retrieve_funder_names/`, {
      headers: send_headers['headers']
    });
  }

  getFunderSummaryData(funder_id) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/retrieve_summary_view/?funder_id=${funder_id}`, {
      headers: send_headers['headers']
    });
  }

  getFunderAggregate() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/retrieve_aggregate_view/`, {
      headers: send_headers['headers']
    });
  }

  // Performance Dashboard
  getFunderMandate(agg_level) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/funder/retrieve_funder_mandate/` ,{
      params: {
        aggregate_level: agg_level
      },
      headers: send_headers['headers']
    });
  }

  // Prediction Dashboard
  getFunderBase(partner, funder) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/prediction/return_funder_prediction/` ,{
      params: {
        partner: partner,
        funder: funder
      },
      headers: send_headers['headers']
    });

  }

  getFunderForecast(partner, funder) {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/prediction/return_funder_forecast/` ,{
      params: {
        partner: partner,
        funder: funder
      },
      headers: send_headers['headers']
    });

  }

  getFunderHeadroom() {

    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/prediction/return_prediction_headroom/` ,{
      headers: send_headers['headers']
    });

  }

  createUser(email, password, firstName, lastName) {
    const send_headers = localStorageTokenInterceptor(this.config);

    const createData = {
      email: email,
      password: password,
      first_name: firstName,
      last_name: lastName,
      idp_id: null,
    };

    return this.apiClient.post('/users/create/', createData, {
      headers: send_headers['headers']
    }).then(
        (resp) => {
          return resp.data;
        });
  }

  // Segmentation
  getSegmentation() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/segment/retrieve_segmentation/` ,{
      headers: send_headers['headers']
    });
  }

  getSummary() {
    const send_headers = localStorageTokenInterceptor(this.config);

    return this.apiClient.get(`/v1/summary/` ,{
      headers: send_headers['headers']
    });
  }

  getVideo() {
    return this.apiClient.get(`/v1/video/` ,{
      params: {
        video: 'second_video.mp4'
      }
    });

  };
}

function localStorageTokenInterceptor(config) {
  const headers = {};
  const tokenString = localStorage.getItem('site');

  if (tokenString) {
    const token = tokenString;
    const decodedAccessToken = jwtDecode(token);
    const isAccessTokenValid =
        moment.unix(decodedAccessToken.exp).toDate() > new Date();
    if (isAccessTokenValid) {
      headers['Authorization'] = `Bearer ${token}`;
    } else {
      localStorage.removeItem('site');
      localStorage.removeItem('user');
    }
  }
  config['headers'] = headers;
  return config;
}

export default APIClient;